import { motion } from "framer-motion";
import { CheckCircle2 } from "lucide-react";

const guarantees = [
  "Profesjonalna, stała kadra trenerska",
  "Małe grupy — maksymalnie 15 osób na trenera",
  "Indywidualnie dobrany program dla każdej grupy",
  "Nauka przez zabawę — zabawa, która uczy",
  "Udział w turniejach w Polsce i za granicą",
  "Szkolenie oparte na wzorcach szkółek niemieckich",
  "Obozy sportowe i półkolonie",
];

export default function About() {
  return (
    <section id="o-nas" data-testid="about-section" className="py-20 lg:py-28 bg-[#F8FAFC]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 grid lg:grid-cols-12 gap-14">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.5 }}
          className="lg:col-span-6"
        >
          <span className="font-accent uppercase tracking-[0.3em] text-blue-700 text-xs font-bold">01 — O nas</span>
          <h2 className="mt-4 font-display font-black uppercase tracking-tighter leading-none text-4xl sm:text-5xl text-[#0B1120]">
            Pasja, która uczy
            <br />
            <span className="text-blue-700">i rozwija</span>
          </h2>
          <div className="mt-8 space-y-5 text-slate-600 text-base font-medium leading-relaxed">
            <p>
              Szkółka Piłkarska „Wichniarek" ma na celu prawidłowy rozwój dziecka
              oraz zainteresowanie go aktywną formą spędzania czasu poprzez udział
              w zajęciach z piłki nożnej.
            </p>
            <p>
              Szkółka powstała z pasji, jaką jest dla nas piłka nożna. Tworzą ją
              osoby od lat związane ze światem piłki nożnej i sportu — trenerzy
              i działacze, dla których najważniejsze są wszechstronny rozwój dziecka
              i radość z gry.
            </p>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.5, delay: 0.15 }}
          className="lg:col-span-6"
        >
          <div className="bg-blue-700 text-[#F8FAFC] p-8 lg:p-10 border-2 border-blue-700 shadow-[8px_8px_0_#FACC15]">
            <h3 className="font-display font-black uppercase tracking-tight text-2xl text-[#FACC15]">
              Gwarantujemy
            </h3>
            <ul className="mt-6 space-y-4">
              {guarantees.map((g, i) => (
                <motion.li
                  key={g}
                  initial={{ opacity: 0, x: 16 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.35, delay: i * 0.05 }}
                  data-testid={`guarantee-item-${i}`}
                  className="flex items-start gap-3 text-sm font-medium text-blue-50"
                >
                  <CheckCircle2 className="text-[#FACC15] shrink-0 mt-0.5" size={18} />
                  {g}
                </motion.li>
              ))}
            </ul>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
